/**
 * Experts list — /app/consult
 *
 * Round 40n.2: reverted to a "Coming soon" placeholder per product
 * decision. The expert collection in MongoDB still has 3 seeded rows
 * and the /consultations/experts API still returns them — we just
 * choose not to surface them in the UI yet. The Dashboard service
 * tile and Landing page teaser still link here so users discover that
 * a consultation flow is in the pipeline without being able to book
 * one prematurely.
 */
import { Card } from '@/components/ui/card';
import { Users } from 'lucide-react';

export default function Experts() {
    return (
        <div className="max-w-5xl mx-auto px-6 py-12 md:py-16" data-testid="experts-page">
            <div className="flex items-center gap-3 mb-3">
                <Users className="text-marigold" size={20} />
                <div className="overline">Human consultations</div>
            </div>
            <h1 className="font-serif text-4xl md:text-5xl text-parchment">
                Book an astrologer
            </h1>
            <p className="mt-4 text-slate-400 max-w-2xl">
                Senior Vedic & KP consultants — your chart and history come pre-loaded.
            </p>

            <Card
                className="mt-10 bg-elevated border-marigold/20 rounded-sm p-12 text-center"
                data-testid="experts-empty"
            >
                <div className="overline mb-3">Coming soon</div>
                <p className="font-serif text-2xl text-parchment leading-snug">
                    Live consultations will be available here shortly.
                </p>
                <p className="mt-3 text-sm text-slate-500 max-w-md mx-auto">
                    In the meantime, chat with Guruji for an instant KP reading or run a Compatibility check.
                </p>
            </Card>
        </div>
    );
}
